/* eslint-disable consistent-return */
import { Flex, Pane, Text } from '@leverege/ui-elements'
import React from 'react'

function NoDelayCodesPane() {
  return (
    <Pane
      variant='dashboardCardCustom'
      style={{
        flex : '1 0 0',
        backgroundColor : '#F3F5F6',
        border : '1px solid #CED6DE',
        minHeight : 250,
      }}>
      <Flex
        variant='colL'
        align='center'
        justify='center'
        style={{ height : '100%' }}
        gap={20}>
        <Text style={{ fontSize : 30, fontWeight : 500 }}>
          No Data Available for Delay Reasons
        </Text>
      </Flex>
    </Pane>
  )
}

export default NoDelayCodesPane
